import styled from 'styled-components';
import { device, spacing } from 'commons';

export const CentralizedContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const Main = styled.div`
  flex: 1;
  height: 100%;
  overflow-y: scroll;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 ${spacing.detailsSidePadding} 100px ${spacing.detailsSidePadding};

  .error {
    color: ${({ theme }) => theme.danger_500};
  }

  @media (max-width: ${device.mobile}px) {
    padding: 0 8px;
    overflow-x: hidden;
  }
`;
